import { CorporateClients } from '@platform/client';
import { Link } from 'wouter';
import { ROUTES } from '../../../routes/consts';

// Reckitt (id 5) and Lumen (id 3) are intentionally not surfaced in the admin corporate list per the
// program team. The API still returns them; we just don't offer a dashboard link here.
const HIDDEN_CORPORATE_CLIENT_IDS = new Set([3, 5]);

export const CorporatesAdmin = () => {
  const { data: corporates, isLoading, isError } = CorporateClients.useGetAllCorporateClients();
  const visibleCorporates = corporates?.filter((c) => !HIDDEN_CORPORATE_CLIENT_IDS.has(c.id));

  return (
    <div className='mx-auto flex w-full max-w-3xl flex-col gap-4 p-4'>
      <h1 className='text-2xl font-semibold'>Corporates</h1>
      <p className='text-gray-600'>Open a corporate client's dashboard.</p>

      {isLoading && <div>Loading...</div>}
      {isError && <div>Error loading corporates</div>}

      {visibleCorporates && (
        <table className='w-full border-collapse'>
          <thead>
            <tr className='border-b text-left text-sm text-gray-500'>
              <th className='py-2 pr-4 font-medium'>Corporate</th>
              <th className='py-2 font-medium'>Dashboard</th>
            </tr>
          </thead>
          <tbody>
            {visibleCorporates.map((corporate) => (
              <tr key={corporate.id} className='border-b'>
                <td className='py-3 pr-4'>{corporate.name}</td>
                <td className='py-3'>
                  <Link
                    className='text-brand-600 font-semibold underline hover:opacity-80'
                    to={`~/platform${ROUTES.CORPORATE_DASHBOARD}?corporateClientId=${corporate.id}`}
                  >
                    View dashboard
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export const CorporateLink = ({
  clientId,
  clientName,
  cohortId,
}: {
  clientId: number;
  clientName: string;
  cohortId?: number;
}) => {
  return (
    <Link
      className='text-brand-500 hover:underline'
      to={`~/platform${ROUTES.CORPORATE_DASHBOARD}?corporateClientId=${clientId}${cohortId ? `&cohortId=${cohortId}` : ''}`}
    >
      {clientName}
    </Link>
  );
};
